import AuthService from "./auth.service";
import { createToast } from "mosha-vue-toastify";
import i18n from "../lang";
import { io } from "socket.io-client";
import store from "../store/index";
import router from "../router";

class SocketService {
	_socket = null;

	connect() {
		const auth = AuthService.authHeader("socket");

		if (!auth.token) {
			return;
		}

		if (this._socket) {
			return;
		}

		this._socket = io(process.env.VUE_APP_WS_PANEL_LINK, {
			auth,
			// transports: ['websocket'],
		});
		this.registerListeners();
	}

	run() {
		this.connect();

		if (!this._socket) {
			return;
		}
	}

	disconnect() {
		if (this._socket) {
			this._socket.disconnect();
			this._socket = null;
		}
	}

	registerListeners() {
		this._socket.on("connect_error", (error) => {
			if (error.data?.type === "UnauthorizedError" || error.message === "ACCESS_LOCKED") {
				createToast(i18n.global.t("panel.socket.expired"), {
					type: "danger",
					position: "top-center",
				});
				store.dispatch("auth/logout");
				this.disconnect();
				router.push("/login");
			}
		});

		this._socket.on("accessRevoked", () => {
			createToast(i18n.global.t("panel.socket.accessRevoked"), {
				type: "danger",
				position: "top-center",
			});
			store.dispatch("auth/logout");
			this.disconnect();
			router.push("/login");
		});

		this._socket.on("updateRoom", (payload) => {
			createToast(i18n.global.t("panel.socket.updatedRoom"), {
				type: "warning",
				position: "top-center",
			});

			store.dispatch("room/updateRoom", payload);
		});

		this._socket.on("updateFiles", (payload) => {
			createToast(i18n.global.t("panel.socket.updatedFiles"), {
				type: "warning",
				position: "top-center",
			});

			store.dispatch("room/updateFiles", payload);
		});

		this._socket.on("removeRoom", (rooms) => {
			createToast(i18n.global.t("panel.socket.roomClosed"), {
				type: "warning",
				position: "top-center",
			});

			store.dispatch("room/removeRoom", rooms);
		});
	}
}

export default new SocketService();
